import React from "react"

import "./loading.css"

const Loading = () => (
  <div className="flex items-center justify-center h-full">
    <div className="loading-wrapper">
      <div className="dna-spinner">
        <div className="strand left">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="center">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="strand right">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  </div>
)

export default Loading
